/**
 * CSV injection, guarded once for every writer.
 *
 * A cell that starts with =, +, - or @ (or a tab or carriage return, which
 * some spreadsheets skip before reading the next character) is run as a
 * formula when the file is opened. A sub-ID, a referrer or a player reference
 * is text somebody else chose, and it lands in an operator's finance download.
 * The server's report export (api-core csv.ts) and the consoles' own table
 * downloads (portal-kit present.ts) both write through this, so the two
 * cannot disagree about which cells are guarded.
 */
/** The leading characters a spreadsheet reads as the start of a formula. */
export const SPREADSHEET_FORMULA_LEAD = /^[=+\-@\t\r]/;
/** The text, with a leading apostrophe where it would otherwise run as a formula. */
export function spreadsheetSafe(text) {
    return SPREADSHEET_FORMULA_LEAD.test(text) ? `'${text}` : text;
}
/**
 * Undo the guard on a file read back: a leading apostrophe directly before one
 * of the guarded characters is ours. Any other apostrophe is somebody's text.
 */
export function spreadsheetUnsafe(text) {
    return /^'[=+\-@\t\r]/.test(text) ? text.slice(1) : text;
}
//# sourceMappingURL=spreadsheet-cell.js.map